"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
var platform_flag_entities_1 = require("../enums/platform-flag-entities");
var flag_builder_1 = require("../builders/flag-builder");
var is_not_empty_string_1 = require("../class-validators/is-not-empty-string");
var class_validator_1 = require("class-validator");
var array_values_also_contained_in_1 = require("../class-validators/array-values-also-contained-in");
var with_default_value_1 = require("../class-transformers/with-default-value");
var class_transformer_1 = require("class-transformer");
var case_insensitive_ingest_1 = require("../class-transformers/case-insensitive-ingest");
var abstract_struct_1 = require("./abstract-struct");
var Flag = (function (_super) {
    __extends(Flag, _super);
    function Flag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Flag.getBuilder = function () { return new flag_builder_1.FlagBuilder(); };
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsDefined)(),
        __metadata("design:type", String)
    ], Flag.prototype, "key", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'display_name' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Flag.prototype, "displayName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Flag.prototype, "description", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'applicable_entities' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsEnum)(platform_flag_entities_1.PlatformFlagEntities, { each: true }),
        (0, class_validator_1.ArrayMinSize)(1),
        (0, class_validator_1.IsArray)(),
        __metadata("design:type", Array)
    ], Flag.prototype, "applicableEntities", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'default_for_entities' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)([]),
        (0, array_values_also_contained_in_1.ArrayValuesAlsoContainedIn)(function (data) { var _a; return (_a = data.applicableEntities) !== null && _a !== void 0 ? _a : []; }, {
            message: 'defaultForEntities can only contain values specified in applicableEntities',
        }),
        (0, class_validator_1.IsEnum)(platform_flag_entities_1.PlatformFlagEntities, { each: true }),
        (0, class_validator_1.IsArray)(),
        __metadata("design:type", Array)
    ], Flag.prototype, "defaultForEntities", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_active' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(false),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Boolean)
    ], Flag.prototype, "isActive", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_dev_only' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(false),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Boolean)
    ], Flag.prototype, "isDevOnly", void 0);
    return Flag;
}(abstract_struct_1.AbstractStruct));
exports.Flag = Flag;
//# sourceMappingURL=flag.js.map